import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SimpleBar from 'simplebar-react'
import { Container, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

//import logo
import logoSm from '../assets/images/logo-sm.png'
import logoDark from '../assets/images/logo-dark.png'
import logoLight from '../assets/images/logo-light.png'

//Import Components
import VerticalLayout from './VerticalLayouts'
import TwoColumnLayout from './TwoColumnLayout'
import HorizontalLayout from './HorizontalLayout'
import themesNavdata from './LayoutThemesMenuData'
import navdata from './LayoutMenuData'

const Sidebar = ({ layoutType }: any) => {
  const location = useLocation()
  const navigate = useNavigate()
  const themesNavData = themesNavdata().props.children
  const navData = navdata().props.children
  const [showLogoutModal, setShowLogoutModal] = useState(false)

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName('vertical-overlay')
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener('click', function () {
        document.body.classList.remove('vertical-sidebar-enable')
      })
    }
  })

  const addEventListenerOnSmHoverMenu = () => {
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active')
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover')
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover')
    }
  }

  const confirmLogout = () => {
    setShowLogoutModal(false)
    navigate('/logout')
  }

  return (
    <React.Fragment>
      <div className='app-menu navbar-menu'>
        <div className='navbar-brand-box'>
          <Link to='/sales' className='logo logo-dark'>
            <span className='logo-sm'>
              <img src={logoSm} alt='' height='22' />
            </span>
            <span className='logo-lg'>
              <img src={logoDark} alt='' height='17' />
            </span>
          </Link>

          <Link to='/sales' className='logo logo-light'>
            <span className='logo-sm'>
              <img src={logoSm} alt='' height='22' />
            </span>
            <span className='logo-lg'>
              <img src={logoLight} alt='' height='48' />
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type='button'
            className='btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover'
            id='vertical-hover'
          >
            <i className='ri-record-circle-line'></i>
          </button>
        </div>
        {layoutType === 'horizontal' ? (
          <div id='scrollbar'>
            <Container fluid>
              <div id='two-column-menu'></div>
              <ul className='navbar-nav' id='navbar-nav'>
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className='sidebar-background'></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id='scrollbar' className='h-100'>
              <Container fluid>
                <div id='two-column-menu'></div>
                <ul className='navbar-nav' id='navbar-nav'>
                  <VerticalLayout
                    layoutType={layoutType}
                    navData={location.pathname.includes('/themes') ? themesNavData : navData}
                  />
                </ul>
                <div className='border-top my-3'></div>
                <div className='px-2 pb-3'>
                  <button
                    className='btn btn-soft-danger w-100 d-flex align-items-center justify-content-center gap-2'
                    onClick={() => setShowLogoutModal(true)}
                  >
                    <i className='mdi mdi-logout fs-16'></i>
                    <span>Logout</span>
                  </button>
                </div>
              </Container>
            </SimpleBar>
            <div className='sidebar-background'></div>
          </React.Fragment>
        )}
      </div>
      <div className='vertical-overlay'></div>

      <Modal isOpen={showLogoutModal} toggle={() => setShowLogoutModal(false)} centered>
        <ModalHeader toggle={() => setShowLogoutModal(false)}>
          Logout
        </ModalHeader>
        <ModalBody className='text-center py-4'>
          <i className='mdi mdi-logout text-danger' style={{ fontSize: '48px' }}></i>
          <h5 className='mt-3'>Are you sure you want to logout?</h5>
          <p className='text-muted mb-0'>Your current session will be ended.</p>
        </ModalBody>
        <ModalFooter className='justify-content-center'>
          <Button color='light' onClick={() => setShowLogoutModal(false)}>
            Cancel
          </Button>
          <Button color='danger' onClick={confirmLogout}>
            Yes, Logout
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default Sidebar
